export function showServices() {

    const servicesItem = document.querySelectorAll('.js-servicesItem');

    const setBtnText = () => {
        servicesItem.forEach( elem => {
            let btns = elem.querySelectorAll('.js-showAllServices');

            btns.forEach(btn => {
                let btnText = elem.classList.contains('is-active') ? 'Скрыть список услуг' : btn.hasAttribute('am-all') ? 'Весь список услуг' : 'Список услуг';
                btn.textContent = btnText;
            })
        });
    }

    const activeList = (elem) => {
        servicesItem.forEach( item => {
            if (item == elem) {
                return false;
            }

            item.classList.remove('is-active');
        });

        if (elem.classList.contains('is-active')) {
            elem.classList.remove('is-active');
        } else {
            elem.classList.add('is-active');
        }
    }

    servicesItem.forEach( (item, index) => {
        item.addEventListener('click', (e) => {
            if (!e.target.classList.contains('js-showAllServices')) {
                return false
            }

            activeList(item);
            setBtnText();
        });
    });
}